import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  EditButton,
  DeleteButton,
  Delete,
  Filter,
  Show,
  SimpleShowLayout,
  RichTextField,
  DateField,
  ReferenceInput,
  SelectInput
} from 'admin-on-rest/lib/mui';

import RichTextInput from 'aor-rich-text-input';
import PrintButton from '../custom/PrintButton';

export const CustomerFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Πελάτης" source="customer" alwaysOn/>
    <ReferenceInput label="Πωλητής" source="seller" reference="users" alwaysOn>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <SelectInput
          label="status"
          source="status"
          choices={[
            { id: 'μη ολοκληρωμένη', name: 'μη ολοκληρωμένη' },
            { id: 'ολοκληρωμένη', name: 'ολοκληρωμένη' }
          ]}
        alwaysOn allowEmpty/>
    {//<DateInput source="time_inserted" label="Ημερομηνία παραγγελίας"  alwaysOn/>
  }

  </Filter>
);

export const OrdersList = (props) => (
  <List {...props} filters={<CustomerFilter />} title="Orders" sort={{ field: 'time_inserted', order: 'DESC' }}  {...props}>
    <Datagrid key={props.customer}>
      <TextField source="customer.code" label="Κωδικος:" />
      <TextField source="customer.name" label="Oνομα:" />
      <DateField source="time_inserted" label="Ημερομηνια:" showTime />
      <DeleteButton/>
      <EditButton/>
      <TextField source="status" label="status" />
      <TextField label="Συνολο" source="sum" />
    </Datagrid>
  </List>
);

export const CreateOrders = (props) => (
  <Create {...props}>
    <SimpleForm>
    <TextInput source="customer" label="Πελάτης:" />
    <TextInput source="name" label="Περιγραφή:" />
    <TextInput source="comments"  label="Σχόλια:"/>
    <TextInput source="clean_sum" label="Καθαρή Αξία:" />
    <TextInput source="sum_fpa" label="Σύνολο με ΦΠΑ:" />
    <RichTextInput source="products" label="Προϊόντα:"  />
    <SelectInput source="status" choices={[
      { id: 'μη ολοκληρωμένη', name: 'μη ολοκληρωμένη' },
      { id: 'ολοκληρωμένη', name: 'ολοκληρωμένη' }
  ]}/>
    </SimpleForm>
  </Create>
);

const OrderTitle = ({ record }) => {
    return <span>{`${record.customer.code+" "+record.customer.name+" "+record.customer.perioxi}` }<br/>{`${"Διεύθυνση: "+record.customer.odos}`}<br/>{`${"Πωλητής: "+record.seller.name+" "+record.seller.surname}`}</span>;
};

export const EditOrders = (props) => (
  <Edit title={<OrderTitle />} {...props}>
    <SimpleForm redirect={false}>
    <TextInput source="comments" label="Σχόλια:" />
    <TextInput source="clean_sum" label="Καθαρή Αξία:" />
    <TextInput source="sum_fpa" label="Σύνολο με ΦΠΑ:" />
    <TextInput source="sum_fpa" label="Σύνολο με ΦΠΑ:" />
    <RichTextInput source="products" label="Προϊόντα:"  />
    <SelectInput source="status" choices={[
      { id: 'μη ολοκληρωμένη', name: 'μη ολοκληρωμένη' },
      { id: 'ολοκληρωμένη', name: 'ολοκληρωμένη' }
  ]}/>
    <PrintButton />
    </SimpleForm>
  </Edit>
);

export const showOrders = (props) => (
    <Show title={<OrderTitle />}{...props}>
  <SimpleShowLayout>
    <TextField source="comments" label="Σχόλια:" />
    <TextField source="clean_sum" label="Καθαρή Αξία:" />
    <TextField source="sum_fpa" label="Σύνολο με ΦΠΑ:" />
    <RichTextField source="products" label="Προϊόντα:"  />
    <PrintButton />
  </SimpleShowLayout>
  </Show>
);

export const DeleteOrders = (props) => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/orders.js